import React, { Component, Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import renderSelectField from '../../../../../shared/components/form/Select';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import PatientEnrollment from '../ClinicalStudio/PatientEnrollment';

class Ananmesis extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cause: "",
            reasonForConsultation: "",
            currentIllness: "",
            load: false,
        };
    }

    render() {
        return (<Fragment>
            <Col md={12} sm={12}>
                <div className={"container-wraper-hc"}>
                    <div className="title-clinic-history">
                        <h4>Anamnesis</h4>
                    </div>
                    <Row>
                        <Col md={6}>
                            <TextField
                                label="Causa de Ingreso"
                                id="select-cause-of-admission"
                                className=" medical-material-form__field"
                                disabled={this.props.isCloseClinicHistory}
                                style={{ width: '100%' }}
                                select
                                value={this.props.anamesis.cause}
                                onChange={(e) => {
                                    this.props.handlerSelectCauseOfAdmission(e.target.value)
                                }}
                            >
                                <MenuItem value={'Enfermedad general'}> Enfermedad general </MenuItem>
                                <MenuItem value={'Enfermedad professional'}> Enfermedad professional </MenuItem>
                                <MenuItem value={'Evento catastrofico'}> Evento catastrofico </MenuItem>
                                <MenuItem value={'Accidente de trabajo'}>  Accidente de trabajo </MenuItem>
                                <MenuItem value={'Accidente de transito'}> Accidente de transito </MenuItem>
                                <MenuItem value={'Accidente ofidico'}>  Accidente ofidico </MenuItem>
                                <MenuItem value={'Otro tipo de accidente'}> Otro tipo de accidente </MenuItem>
                                <MenuItem value={'Lesion auto infligida'}> Lesion auto infligida </MenuItem>
                                <MenuItem value={'Lesion por agresion'}> Lesion por agresion </MenuItem>
                                <MenuItem value={'Sospecha abuso sexual'}> Sospecha abuso sexual </MenuItem>
                                <MenuItem value={'Sospecha maltrato emocional'}> Sospecha maltrato emocional </MenuItem>
                                <MenuItem value={'Sospecha maltrato fisico'}> Sospecha maltrato fisico </MenuItem>
                                <MenuItem value={'Sospecha violencia sexual'}> Sospecha violencia sexual </MenuItem>
                                <MenuItem value={'Otra'}> Otra </MenuItem>
                            </TextField>
                        </Col>
                        {
                            this.props.dataClinicalStudio != null && this.props.dataClinicalStudio != undefined ?
                                <>
                                    <PatientEnrollment
                                        handlerCandidate={(value) => this.props.handlerCandidate(value)}
                                        handlerParticipate={(value) => this.props.handlerParticipate(value)}
                                        dataClinicalStudio={this.props.dataClinicalStudio}
                                        candidate={this.props.anamesis.candidate}
                                        participate={this.props.anamesis.participate}
                                    />
                                </> : null
                        }
                    </Row>

                    <div className="form" style={{ flex: 1, flexDirection: 'column', margin: '1em 0em' }}>

                        <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
                            <div className="form__form-group" style={{ margin: 10 }}>
                                <span className="common-label-section-others">Motivo de Consulta</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-reason-for-consultation"
                                        component="textarea"
                                        disabled={this.props.isCloseClinicHistory}
                                        type="text"
                                        value={this.props.anamesis.reasonForConsultation}
                                        onChange={(e) => {
                                            this.props.handlerReasonForConsultation(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
                            <div className="form__form-group" style={{ margin: 10 }}>
                                <span className="common-label-section-others">Enfermedad Actual</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-current-illness"
                                        component="textarea"
                                        disabled={this.props.isCloseClinicHistory}
                                        type="text"
                                        value={this.props.anamesis.currentIllness}
                                        onChange={(e) => {
                                            this.props.handlerCurrentIllness(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </Col>



        </Fragment>);
    }
}

export default reduxForm({
    form: `ananmesis-form`, // a unique identifier for this form
})(withTranslation('common')(Ananmesis));